(ns minorodata.data-views.subs
  (:require [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]))

(re-frame/reg-sub
 :data-views.subs/data-views-all
 (fn []
   (re-frame/subscribe [:data-views-all/pull '[{:data-views-all/data-views [:*
                                                                            {:data-view/updated-by [:searchable-user/id :searchable-user/username]
                                                                             :data-view/created-by [:searchable-user/id :searchable-user/username]}]}]]))
 (fn [data-view-list]
   (let [{:data-views-all/keys [data-views]} data-view-list]
     (reverse (sort-by :data-view/created-at data-views)))))

(re-frame/reg-sub
 :data-views.subs/data-views-shared
 (fn []
   (re-frame/subscribe [:data-views-shared/pull '[{:data-views-shared/data-views [:*
                                                                                  {:data-view/updated-by [:searchable-user/id :searchable-user/username]
                                                                                   :data-view/created-by [:searchable-user/id :searchable-user/username]}]}]]))
 (fn [data-view-list]
   (let [{:data-views-shared/keys [data-views]} data-view-list]
     (reverse (sort-by :data-view/created-at data-views)))))

(re-frame/reg-sub
 :data-views.subs/data-views-created
 (fn []
   (re-frame/subscribe [:data-views-created/pull '[{:data-views-created/data-views [:*
                                                                                    {:data-view/updated-by [:searchable-user/id :searchable-user/username]
                                                                                     :data-view/created-by [:searchable-user/id :searchable-user/username]}]}]]))
 (fn [data-view-list]
   (let [{:data-views-created/keys [data-views]} data-view-list]
     (reverse (sort-by :data-view/created-at data-views)))))

(re-frame/reg-sub
 :data-views.subs/data-view
 (fn [[_ id]]
   (re-frame/subscribe [:data-view/pull [:data-view/data-view-id id] '[*
                                                                      {:data-view/updated-by [:searchable-user/id :searchable-user/username]
                                                                       :data-view/created-by [:searchable-user/id :searchable-user/username]}]]))
 (fn [v] v))

(re-frame/reg-sub
 :data-views.subs/preview-data
 (fn []
   (re-posh/subscribe [:data-views-page/prop :data-views-page/data]))
 (fn [data]
   (if (empty? data)
     nil
     (for [statement data]
       (let [headers         (first statement)
             rows            (next statement)
             indexed-headers (map-indexed (fn [idx h] [idx h]) headers)

             indexed-header-id (fn [[idx c]] (str idx "-" c))
             indexed-col-fn    (fn [[idx c]] {:title c :field (indexed-header-id [idx c])})
             col-fn            (fn [c] {:title c :field c})

             indexed-header-ids (map indexed-header-id indexed-headers)]
         (when (and (some? data)
                    (some? headers))
           {:data    (mapv (fn [cols] (apply assoc {} (interleave headers cols)))
                           rows)
            :headers (map col-fn headers)

            :indexed-data    (mapv (fn [cols] (apply assoc {} (interleave indexed-header-ids cols)))
                                   rows)
            :indexed-headers (map indexed-col-fn indexed-headers)}))))))

(re-frame/reg-sub
 :data-views.subs/can-modify
 (fn [] (re-frame/subscribe [:user/pull]))
 (fn [{:user/keys [uid]} [_ {:data-view/keys [created-by]}]]
   (or (= uid (:searchable-user/id created-by))
       @(re-posh/subscribe [:users.subs/admin?]))))
